<template>
    <div>
        <v-card class="mt-2">
            <v-card-title class="pa-2">
                <v-btn color="primary" class="m-0" @click="onBackKey"><v-icon left>mdi-arrow-left-bold-circle-outline</v-icon>Back</v-btn>
                <v-spacer></v-spacer>
                <label v-text="editingLicense.licenseKey"></label>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mr-4" @click="onWebSyncUser"><v-icon left>mdi-account-outline</v-icon>WebSync User</v-btn>
                <v-btn color="primary" class="mr-4" @click="onFullKey"><v-icon left>mdi-comment-processing-outline</v-icon>Full License Key</v-btn>
                <v-btn color="primary" class="m-0" @click="onTransfer" :disabled="editingLicense.active === false"><v-icon left>mdi-transfer</v-icon>Transfer</v-btn>

                <v-dialog v-model="transferDialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                        <span class="headline">Transfer To</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="transferTo" label="Email"></v-text-field>
                                        </v-col>
                                    </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeTransfer">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="saveTransfer" :disabled="transferring">Transfer</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </v-card-title>
        </v-card>
        <v-card class="mt-2" >
            <v-stepper non-linear v-model="licenseStep" alt-labels>
                <v-stepper-header>
                    <v-stepper-step editable step="A" @click="onAuditStepClick">Audit</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="D">Details</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="E" @click="onExceptionsStepClick">Exceptions</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="I" @click="onInstancesStepClick">Instances</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="L" @click="onLogsStepClick">Logs</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="N" @click="onNotesStepClick">Notes</v-stepper-step>
                </v-stepper-header>
                <v-stepper-content step="A">
                    <v-card-title class="pa-2">
                        <label>Audit</label>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table dense :headers="auditTable.headers" :items="auditTable.audit" :loading="isBusy" :loading-text="auditTable.loadingText" default-sort="dateTime:desc">
                    </v-data-table>
                </v-stepper-content>
                <v-stepper-content step="D">
                    <v-card-title class="pa-2">
                        <label>Details</label>
                    </v-card-title>
                    <v-row dense>
                        <v-col>
                            <v-checkbox  v-model="editingLicense.active" label="Active" readonly></v-checkbox>
                            <v-text-field v-model="editingLicense.licenseTypeGUID" label="Type" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.firm" label="Company" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.email" label="Email" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.created" label="Created" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.systemID" label="System ID" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.transferredTo" label="Transferred To" readonly></v-text-field>
                        </v-col>
                        <v-col>
                            <v-checkbox disabled v-model="editingLicense.handshakeFailBlock" label="Handshake Block"></v-checkbox>
                            <v-text-field v-model="editingLicense.dealerGUID" label="Dealer" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.name" label="Name" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.mobile" label="Mobile" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.installed" label="Installed" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.machineID" label="Machine ID" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.pulse" label="Pulse" readonly></v-text-field>
                        </v-col>
                        <v-col>
                            <v-checkbox disabled v-model="editingLicense.strictSystemIDs" label="Strict System IDs"></v-checkbox>
                            <v-text-field v-model="editingLicense.firmGUID" label="Firm" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.telephone" label="Telephone" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.expires" label="Expires" readonly></v-text-field>
                            <v-text-field v-model="editingLicense.instanceLimit" label="Instances" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col>
                            <v-label>Products</v-label>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.ifrs" label="IFRS"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.grap" label="GRAP"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.rac" label="RAC"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.cet" label="CET"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.tvet" label="TVET"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.cloud" label="CLOUD"></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-label>Institutes</v-label>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.iac" label="IAC"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.saiba" label="SAIBA"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.saica" label="SAICA"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.saipa" label="SAIPA"></v-checkbox>
                            <v-checkbox class="ma-0" readonly v-model="editingLicense.other" label="Other"></v-checkbox>
                        </v-col>
                        <v-col>
                        </v-col>
                    </v-row>

                </v-stepper-content>
                <v-stepper-content step="E">
                    <v-card-title class="pa-2">
                        <label>Exceptions</label>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table dense :headers="exceptionsTable.headers" :items="exceptionsTable.exceptions" :loading="isBusy" :loading-text="exceptionsTable.loadingText">
                    </v-data-table>
                </v-stepper-content>
                <v-stepper-content step="I">
                    <v-card-title class="pa-2">
                        <label>Instances</label>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table dense :headers="instancesTable.headers" :items="instancesTable.instances" :loading="isBusy" :loading-text="instancesTable.loadingText">
                    </v-data-table>
                </v-stepper-content>
                <v-stepper-content step="L">
                    <v-card-title class="pa-2">
                        <label>Logs</label>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table dense :headers="logsTable.headers" :items="logsTable.logs" :loading="isBusy" :loading-text="logsTable.loadingText">
                    </v-data-table>
                </v-stepper-content>
                <v-stepper-content step="N">
                    <v-card-title class="pa-2">
                        <label>Notes</label>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = true">New Note</v-btn>
                        <v-dialog v-model="dialog" max-width="500px">
                            <v-card>
                                <v-card-title>
                                <span class="headline">New Note</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-layout >
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-textarea ref="newNote" v-model="editedItem.note" label="Note" counter="500"></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-title>
                    <v-data-table dense :headers="notesTable.headers" :items="notesTable.notes" :loading="isBusy" :loading-text="notesTable.loadingText" default-sort="noteDateTime:desc">
                        <template v-slot:[`item.action`]="{ item }">
                            <v-icon small :disabled="!($global.login.administrator || item.notedBy == $global.login.email)" @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-stepper-content>
            </v-stepper>
        </v-card>
        <v-snackbar v-model="snackbar.visible" color="primary" :timeout="snackbar.timeout" :bottom="snackbar.bottom">
            Transfered
            <v-btn dark text @click="snackbar.visible=false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "LicenseView",
    props: {
        editingLicense: {
        },
    },
    data() {
        return {
            title: "License",
            isBusy: false,
            dialog: false,
            transferDialog: false,
            licenseStep: "D",
            snackbar: {
                visible: false,
                timeout: 1000,
                bottom: true,
            },
            editedIndex: -1,
            editedItem: {
                note: "",
            },
            defaultItem: {
                note: "",
            },
            notesTable: {
                loadingText: "loading notes",
                headers: [
                    { text: "Date", value: "noted" },
                    { text: "User", value: "notedBy", sortable: false },
                    { text: "Note", value: "note" },
                    { text: "Actions", value: "action", sortable: false },
                ],
                notes: [],
            },
            auditTable: {
                loadingText: "loading audit trail",
                headers: [
                    { text: "Date", value: "audited" },
                    { text: "User", value: "actionBy", sortable: false },
                    { text: "Action", value: "action" },
                    { text: "Description", value: "description" },
                ],
                notes: [],
            },
            exceptionsTable: {
                loadingText: "loading exceptions",
                headers: [
                    { text: "Date", value: "exported" },
                    { text: "Draftworx", value: "draftworxVersion" },
                    { text: "Description", value: "description" },
                ],
                exceptions: [],
            },
            instancesTable: {
                loadingText: "loading instances audit",
                headers: [
                    { text: "Date", value: "exported" },
                    { text: "Draftworx", value: "draftworxVersion" },
                    { text: "Windows", value: "windowsVersion" },
                    { text: "Instances", value: "instances" },
                ],
                instances: [],
            },
            logsTable: {
                loadingText: "loading logs",
                headers: [
                    { text: "Draftworx", value: "draftworxVersion" },
                    { text: "Windows", value: "windowsVersion" },
                    { text: "Opened", value: "opened" },
                    { text: "Closed", value: "closed" },
                    { text: "Date ID", value: "dateID" },
                ],
                logs: [],
            },
            transferring: false,
            transferTo: "",
        };
    },
    mounted() {
    },
    methods: {
        onBackKey() {
            this.$emit("onBackKey");
        },
        onWebSyncUser() {
            this.isBusy = true;
            this.$http
                .get(`/api/user/websync/${this.editingLicense.firmGUID}/${this.editingLicense.email}/`)
                .then((response) => {
                    this.isBusy = false;
                    this.$alert({ type: "info", title: "WebSync User", message: response.data });

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "websync",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "WebSync Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        onFullKey() {
            this.isBusy = true;
            this.$http
                .get(`/api/license/validated/${this.editingLicense.licenseKey}`)
                .then((response) => {
                    this.isBusy = false;
                    this.$alert({ type: "info", title: "Validated License Key", message: response.data });
                    navigator.clipboard.writeText(response.data);

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "fullkey",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        onTransfer() {
            this.transferring = false;
            this.transferDialog = true;
        },
        onNotesStepClick() {
            this.isBusy = true;
            this.notesTable.notes = [];

            this.$http
                .get(`/api/license_note/search/${this.editingLicense.licenseKey}`)
                .then((response) => {
                    this.notesTable.notes = response.data;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "notes.search",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        onInstancesStepClick() {
            this.isBusy = true;
            this.instancesTable.instances = [];

            this.$http
                .get(`/api/license/instances/${this.editingLicense.licenseKey}`)
                .then((response) => {
                    this.instancesTable.instances = response.data;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "instances.search",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        onLogsStepClick() {
            this.isBusy = true;
            this.logsTable.logs = [];

            this.$http
                .get(`/api/license_log/search/${this.editingLicense.licenseKey}`)
                .then((response) => {
                    this.logsTable.logs = response.data;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "logs.search",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        onAuditStepClick() {
            this.isBusy = true;
            this.auditTable.audit = [];

            this.$http
                .get(`/api/license_audit/search/${this.editingLicense.licenseKey}`)
                .then((response) => {
                    this.auditTable.audit = response.data;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "audit.search",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        onExceptionsStepClick() {
            this.isBusy = true;
            this.exceptionsTable.exceptions = [];

            this.$http
                .get(`/api/license_exception/search/${this.editingLicense.licenseKey}`)
                .then((response) => {
                    this.exceptionsTable.exceptions = response.data;
                    this.isBusy = false;

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "exceptions.search",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        getFormattedDate(date) {
            return moment(date).format("DD MMM YYYY");
        },
        getFormattedDateAndTime(date) {
            return moment(date).format("DD MMM YYYY HH:MM");
        },
        deleteItem(item) {
            this.editedIndex = this.notesTable.notes.indexOf(item);
            this.editedItem = this.notesTable.notes[this.editedIndex];

            this.$confirm({
                title: "Confirm Delete",
                message: "Are you sure you wish to delete this note?",
            }, (value) => {
                if (value) {
                    this.deleteNote();
                }
            });
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },
        save() {
            if (this.editedIndex > -1) {
                Object.assign(this.notesTable.notes[this.editedIndex], this.editedItem);
            }
            else {
                this.saveNewNote();
            }
        },
        closeTransfer() {
            this.transferDialog = false;
            this.transferTo = "";
        },
        saveTransfer() {
            if (this.transferTo !== "") {
                this.transferring = true;
                this.isBusy = true;
                const editingLicense = this.editingLicense;
                this.$http
                    .post(`/api/license/transfer`, {
                        license: this.editingLicense.licenseKey,
                        email: this.transferTo,
                    })
                    .then((response) => {
                        this.isBusy = false;
                        editingLicense.transferredTo = response.data;
                        editingLicense.active = false;
                        this.closeTransfer();
                        this.snackbar.visible = true;

                        this.$ga.event({
                            eventCategory: "licenses",
                            eventAction: "transfer",
                        });
                    })
                    .catch((err) => {
                        this.isBusy = false;
                        if (err.response.status === 401) {
                            this.$router.push({ name: "login" });
                        }
                        else {
                            this.$alert({ type: "error", title: "Transfer Failed", message: err.response.data.exceptionMessage });
                        }
                    });
            }
        },

        saveNewNote() {
            this.isBusy = true;
            this.editedItem.licenseKey = this.editingLicense.licenseKey;
            this.editedItem.notedBy = this.$global.login.email;
            this.$http
                .post(`/api/license_note/create`, {
                    applicationGUID: this.$global.application,
                    licenseKey: this.editedItem.licenseKey,
                    note: this.editedItem.note,
                })
                .then((response) => {
                    this.isBusy = false;
                    this.editedItem.noted = moment().format("DD MMM YYYY HH:MM:SS");
                    this.editedItem.noteGUID = response.data;
                    this.notesTable.notes.unshift(this.editedItem);
                    this.close();

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "notes.create",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
        deleteNote() {
            this.isBusy = true;

            this.$http
                .delete(`/api/license_note/delete/${this.editedItem.noteGUID}`)
                .then(() => {
                    this.isBusy = false;
                    this.notesTable.notes.splice(this.editedIndex, 1);

                    this.$ga.event({
                        eventCategory: "licenses",
                        eventAction: "notes.delete",
                    });
                })
                .catch((err) => {
                    this.isBusy = false;
                    if (err.response.status === 401) {
                        this.$router.push({ name: "login" });
                    }
                    else {
                        this.$alert({ type: "error", title: "Delete Failed", message: err.response.data.exceptionMessage });
                    }
                });
        },
    },
};
</script>
